import React, { useState } from 'react'
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import Select from "react-select";
import axios from 'axios';
import * as Icon from 'react-bootstrap-icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useGetAllProjects from '../../Common/ReuseApi/useGetAllProjects';
import useGetAllManagers from '../../Common/ReuseApi/useGetAllManagers';

const AssignManagerToProjectModel = ({ show, close }) => {

  const [managerName, setManagerName] = useState(null)
  const [projectName, setProjectName] = useState(null)
  const [errState, setErrState] = useState({
    managerName: '',
    projectName: '',
  })

  const { allProjectOptionsById } = useGetAllProjects();
  const { data: allManagerOptions } = useGetAllManagers({
    manager: "managers"
  });
  const isNotValidForm = Object.values(errState).some(item => item);

  const resetForm = () => {
    setManagerName(null)
    setProjectName(null)
    setErrState({
      managerName: '',
      projectName: '',
    })
  }

  const handleAssign = () => {

    // VALIDATE DATA
    const errObj = {
      managerName: '',
      projectName: '',
    }

    if (!managerName || !managerName.value || !managerName.label) {
      errObj.managerName = 'Manager Is Required'
    }

    if (!projectName || !projectName.value || !projectName.label) {
      errObj.projectName = 'Project Is Required'
    }

    const isNotValid = Object.values(errObj).some(item => item);
    setErrState(errObj)

    if (isNotValid) {
      return;
    }


    const payload = {
      "empId": managerName?.value,
      "empName": managerName?.label,
      "projectId": projectName?.value,
    }

    const endpoint = '/project/assignManagerToProject';

    axios.post(process.env.REACT_APP_BASE_URL + endpoint, payload)
      .then((res) => {
        if (res.data.status === 200) {
          toast.success(res.data.msg, {
            toastId: "assign-manager-project-success"
          });

          setTimeout(() => {
            resetForm();
            close()
          }, 500)
        }
        else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => {
        console.log("Error", err)
      })
  }



  return (
    <>
      <Modal show={show} onHide={close} size="lg" centered backdrop='static' keyboard={false}>
        <Modal.Header closeButton className="mngmodelheader">
          <Modal.Title>
            <h5>Assign Project </h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body size="lg">
          <Row className='mb-4'>

            <Col sm={12} md={6}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Manager
                  {/* <span className="requiredfield">*</span> */}
                </Form.Label>
                <Select
                  placeholder="Select Manager"
                  isMulti={false}
                  isSearchable={true}
                  value={managerName}
                  options={allManagerOptions}
                  onChange={(option) => {
                    setManagerName(option);
                    setErrState((prev) => ({
                      ...prev,
                      managerName: ''
                    }))
                  }}
                />
                {
                  errState.managerName && (
                    <Form.Text className="text-danger">
                      {errState.managerName}
                    </Form.Text>
                  )
                }
              </Form.Group>
            </Col>

            <Col sm={12} md={6}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Project
                  {/* <span className="requiredfield">*</span> */}
                </Form.Label>
                <Select
                  placeholder="Select Project"
                  isMulti={false}
                  isSearchable={true}
                  value={projectName}
                  options={allProjectOptionsById}
                  onChange={(option) => {
                    setProjectName(option);
                    setErrState((prev) => ({
                      ...prev,
                      projectName: ''
                    }))
                  }}
                />
                {
                  errState.projectName && (
                    <Form.Text className="text-danger">
                      {errState.projectName}
                    </Form.Text>
                  )
                }
              </Form.Group>
            </Col>

          </Row>
        </Modal.Body>

        <Modal.Footer
          className="text-center mt-4"
        >
          <Button
            className={`${isNotValidForm ? 'CancelBtn' : 'primaryBtn'}`}
            onClick={handleAssign}
            disabled={isNotValidForm}
          >
            <Icon.PersonAdd className='me-2' /> Assign
          </Button>
        </Modal.Footer>

      </Modal>
    </>

  )
}

export default AssignManagerToProjectModel